import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LoadingScreen from '../../components/LoadingScreen';
import ErrorScreen from '../../components/Error';

const ProductContextScreen = ({ isLoading, hasError }) => {
  const { t } = useTranslation();

  if (isLoading || !hasError) {
    return <LoadingScreen />;
  }

  return <ErrorScreen errorMessage={t('context:contextError')} />;
};

ProductContextScreen.defaultProps = {
  isLoading: true,
  hasError: false,
};

ProductContextScreen.propTypes = {
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default ProductContextScreen;
